import { render, staticRenderFns } from "./RentalIntroPage.vue?vue&type=template&id=0b47859a&"
import script from "./RentalIntroPage.vue?vue&type=script&lang=js&"
export * from "./RentalIntroPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports